<span [ngbTooltip]="(disabled ? 'not.authorized' : '') | translate" placement="left">
  <button (click)="onDelete()" [disabled]="disabled" class="dropdown-item">
    <i [style.color]="disabled ? 'grey' : 'red'" class="fas fa-trash me-2"></i>{{ "ech0134.grundbuchmeldungen.delete" | translate }}
  </button>
</span>
